import DatatablesController from '../../../../datatables_controller';

export default class extends DatatablesController {
  datatableColumns() {
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'left',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'author_name',
        title: 'Penulis',
        overflow: 'visible',
        autoHide: false,
        width: 160,
        template: function(data) {
          return `
            <div>
              <span class="font-weight-bolder d-block">${data.author_name || '-'}</span>
              <span class="text-muted font-size-sm">@${data.author_username || ''}</span>
            </div>
          `;
        }
      },
      {
        field: 'content',
        title: 'Konten',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="text-muted">${data.content || '-'}</span>`;
        }
      },
      {
        field: 'thread_type',
        title: 'Tipe',
        sortable: false,
        overflow: 'visible',
        autoHide: false,
        width: 80,
        template: function(data) {
          const badges = { post: 'primary', reply: 'info', repost: 'secondary' };
          const color = badges[data.thread_type] || 'light';
          return `<span class="badge badge-${color}">${data.thread_type || '-'}</span>`;
        }
      },
      {
        field: 'is_hidden',
        title: 'Status',
        sortable: false,
        overflow: 'visible',
        autoHide: false,
        width: 100,
        template: function(data) {
          if (data.is_hidden) {
            return `<span class="badge badge-danger">Tersembunyi</span>`;
          }
          if (data.flagged_count > 0) {
            return `<span class="badge badge-warning">Ditandai</span>`;
          }
          return `<span class="badge badge-success">Terlihat</span>`;
        }
      },
      {
        field: 'flagged_count',
        title: 'Flags',
        overflow: 'visible',
        autoHide: false,
        width: 60,
        template: function(data) {
          if (data.flagged_count > 0) {
            return `<span class="badge badge-danger">${data.flagged_count}</span>`;
          }
          return `<span class="text-muted">0</span>`;
        }
      },
      {
        field: 'created_at',
        title: 'Tanggal',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="text-muted font-size-sm">${data.created_at || '-'}</span>`;
        }
      },
      {
        field: 'Actions',
        title: 'Aksi',
        sortable: false,
        width: 80,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `
            <a class="btn btn-sm btn-clean btn-icon" href="${data.show_path}" title="Lihat Detail">
              <i class="fa fa-eye text-primary"></i>
            </a>
          `;
        }
      }
    ];
  }
}
